// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("../../Json.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var TypeUtils = require("../TypeUtils.bs.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");

var include = TypeUtils.MakeOpaqueStringType({});

var decode = include.decode;

var encode = include.encode;

function decode$1(json) {
  return Curry._2(Json.Decode.$less$pipe$great, Curry._1(decode, json), Curry._2(Json.Decode.$great$great$eq, Relude_Result.map((function (param) {
                        return Relude_Globals.$great$great(Relude_Int.toString, (function (prim) {
                                      return prim;
                                    }), param);
                      }), Json.Decode.intFromNumberOrString(json)), decode));
}

function parse(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great(decode$1, Relude_Result.toOption, param);
              }), Relude_Option.getOrThrow, param);
}

var GraphQL_API = {
  parse: parse,
  serialize: encode
};

var fromString = include.fromString;

var toString = include.toString;

var compare = include.compare;

var eq = include.eq;

var Ord = include.Ord;

var $$Set = include.$$Set;

var $$Map = include.$$Map;

exports.fromString = fromString;
exports.toString = toString;
exports.encode = encode;
exports.compare = compare;
exports.eq = eq;
exports.Ord = Ord;
exports.$$Set = $$Set;
exports.$$Map = $$Map;
exports.decode = decode$1;
exports.GraphQL_API = GraphQL_API;
/* include Not a pure module */
